import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ruCommon from './locales/ru/common.json';
import ruLanding from './locales/ru/landing.json';
import ruAnalysis from './locales/ru/analysis.json';
import ruLegal from './locales/ru/legal.json';
import ruExamples from './locales/ru/examples.json';
import ruPublicShares from './locales/ru/publicShares.json';

import enCommon from './locales/en/common.json';
import enLanding from './locales/en/landing.json';
import enAnalysis from './locales/en/analysis.json';
import enLegal from './locales/en/legal.json';
import enExamples from './locales/en/examples.json';
import enPublicShares from './locales/en/publicShares.json';

import { getLangFromPath } from '../utils/routeUtils';

export type Language = 'ru' | 'en';

const resources = {
  ru: {
    common: ruCommon,
    landing: ruLanding,
    analysis: ruAnalysis,
    legal: ruLegal,
    examples: ruExamples,
    publicShares: ruPublicShares,
  },
  en: {
    common: enCommon,
    landing: enLanding,
    analysis: enAnalysis,
    legal: enLegal,
    examples: enExamples,
    publicShares: enPublicShares,
  },
};

const defaultLang: Language = 'ru';

/** Язык при загрузке: из URL (/en/ или /ru/), иначе из localStorage, иначе ru. Убирает мигание при открытии /en/. */
function getInitialLanguage(): Language {
  if (typeof window === 'undefined') return defaultLang;
  const urlLang = getLangFromPath(window.location.pathname);
  if (urlLang) return urlLang;
  const saved = localStorage.getItem('plinus-language') as Language | null;
  return saved || defaultLang;
}

i18n.use(initReactI18next).init({
  lng: getInitialLanguage(),
  fallbackLng: defaultLang,
  ns: ['common', 'landing', 'analysis', 'legal', 'examples', 'publicShares'],
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  resources,
});

export { i18n };
export default i18n;
